module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch06"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“The vault room dates from the late nineteenth century,” said the Peruvian election official who met Lia and Fernandez at the bank. “It has survived several robbery attempts, including one by Yankee banditos. There are still scratches on the outside of the door from the dynamite when they tried to blow it up. The room here—” He swung around, gesturing at the high-ceilinged lobby. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mucho")]), _vm._v(" damage. Very severe. But not the vault. The gold remained safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tell her who the bandits were,” Fernandez prompted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Butch Cassidy and the Sundance Kid. It is rumor, only.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A false one, Lia knew—it had been mentioned during her briefing. The western outlaws had spent time in Bolivia and elsewhere in Latin America, but they’d never come to Peru.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not to mention the fact that the safe had been built several years after they died. But it was a good story, and Lia saw no sense in interrupting the man as he fleshed it out with a legend about a local romance between Cassidy and the wife of the bank president. Feigning interest, Lia turned her real attention to the security setup, making sure it jibed with what she’d been told by the Art Room on the way over, as well as during her earlier briefing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The vault was a large steel and concrete encased room, partly underground, sealed by an impressively massive steel door. The room had its own level a few steps down from the lobby. There were two restrooms to the left along a narrow hallway and two equipment closets jammed with gear to the right. Surveillance cameras, both video and infrared, monitored the lobby and vault entrance. There were also motion detectors, but the system had been turned off because guards were now in the bank around the clock.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Two stood just inside the main entrance. They were armed with MP5 submachine guns. Two more guards, also with submachine guns, stood along the rail above the vault floor. A final pair stood just outside the vault door. There were plainclothes guards at the foot of the steps from the lobby; they checked credentials of anyone entering the vault. A trio of Peruvian election officials assisted them and tried to look as important as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A reporter had come to the bank to do a story on the procedures that had been adopted to ensure a fair election, as well as some of the security surrounding the voting machines and related equipment. Though not allowed into the vault itself, he was being given a lecture near the security checkpoint by a carefully coiffured Peruvian government official, who assured him the special voter cards stored here guaranteed an honest result.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They must have done a dozen interviews here in the last week and a half,” Fernandez told Lia. “The cards and the vault have become symbols of the fairness of the election.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The official had a model of one of the cards in his hand, holding it out for the man to see. About half as big as a credit card, it looked like a Bic cigarette lighter that had been flattened by a cement mixer. A tapered end housed eight small tonguelike connectors, the slivers of metal looking a bit like flat piano keys. The indentations in the connectors added to the complexity of counterfeiting them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This allows the vote to be recorded,” the official said in a sonorous voice. “No impostors.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He explained that there would only be three cards per voting place and that they had to be entered each time to record a vote. The cards included a chip that produced a 128-byte “key” that “unlocked” communications between two different parts of the system, which as a layman’s explanation of the security system was nearly as good as the considerably more technical brief Lia had received during the mission planning. Since the chips were custom designed and had been delivered only a week before, anyone interested in beating the encryption, let alone duplicating the cards, faced an almost insurmountable task.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unless the cards had been hacked before they were supplied. In that case, rather than guaranteeing a fair vote, the cards could be used to steal the election rather easily. Which was the reason Lia was here.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Six days ago, an informant at the company that made the chips told the FBI that twelve cards had been engineered to guarantee that Ramon Ortez, the current vice president, would win. The informant had supplied a list of serial numbers for the chips used on the cards; the IDs were not written on the chips or the cards but could be obtained by querying them with a special reader.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The hack was extremely sophisticated—so much so that it had taken the NSA’s experts nearly a day and a half to decide that it was conceptually possible and then design a way to test the cards, which were already in Peru.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Making sure Peru’s elections were held had become a priority for the U.S. following several reversals for democracy in other South American countries over the past six months, including a coup in Brazil. But the fact that Ortez was known to be rabidly anti-U.S. complicated the situation, as did his intimate relation with the current government.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The U.S. couldn’t announce that the cards had been hacked without being absolutely certain that they were. The hack had gone undetected by all of the earlier tests the monitors employed. Working undercover as a specialist brought in for a last-minute check, Lia would upload data from one of the cards so that the NSA specialists could determine whether it was indeed a clever hack or an even more clever hoax.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The question was, what happened next? If the cards had been tampered with, simply revealing the hack might backfire. The company that had made the cards was American, and Ortez would surely claim that the U.S. had set him up. Public sentiment in the region was running heavily against the U.S., and it was very likely he’d be believed. Meanwhile, the UN election committee had indicated that if it detected fraud it would call for a delay in the election. That would also hand Ortez the presidency—the current president was very sick and had already indicated that, election or no, he would retire in a month. Ortez would assume the presidency and most likely cancel the election completely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Desk Three had been tasked with verifying that the cards had been hacked. If that proved to be the case, the NSA’s covert action team would then clandestinely replace the bad cards with good ones—assuming the U.S. president gave the final OK.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The cards were stored temporarily in the large vault before being shipped to the regional election centers just before voters went to the polls. They were packed three to a tamper-evident envelope and stacked in narrow, shoe box-size boxes inside. Even though the envelopes could be identified by numbered bar codes on the outside, the odds against picking all twelve cards out of the thousands and thousands of envelopes were greater than one in 15 million.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fortunately, Deep Black had a way to beat the odds. The cards had been placed into the envelopes by a random sorting machine, ostensibly to further decrease the possibility of fraud, since no one on the production line would know where the cards were going. But like many supposedly random number generators, the sorting program was not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" random. It used only two variables, and since the NSA analysts already knew one—it was a set permutation of the time the program was initiated—they could easily solve for the other. All they needed were the IDs of the cards in two envelopes; from that, they could map the entire collection. They would know where each card was without opening the envelopes. (Technically, they only needed the serial numbers from one card in one envelope to find the solution. But they would use two envelopes and test the full set to be sure.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lia’s first priority today was to map the location of the cards in the envelopes. Then she would locate one of the suspect cards and swap it with the duplicate that had been fitted to the back of her belt buckle. The card would be taken out and tested; if it was hacked, the team would proceed to replace the rest of the cards. They had developed several different plans to do this and would choose the best depending on the specific circumstances at the time. Unlike many Deep Black missions, which involved weeks and even months of planning, the Peru operation had been mounted in only a few days. Its success—for Lia, there was no option other than success—depended to a large degree on the ability of the field ops to adapt to the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One option would be for Lia to return the next day to swap out the rest of the cards. Her cover gave her carte blanche to randomly test the cards as well as the machines, so she was guaranteed all the access she needed; all she had to do was wait for her opportunity. She could also opt to swap all twelve cards if the opportunity presented itself inside, using the complete set of twelve cards hidden in the lining of the bag. Lia had suggested that option herself, arguing that it might prove simpler to simply replace all of the suspect cards on her first visit if she wasn’t being watched too carefully.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The setup outside the vault argued that wasn’t likely. Even though she’d already passed through a metal detector and an explosive sniffer at the door, Lia had to run a similar gamut at the base of the steps leading down to the vault room. The sniffer could detect common explosives such as HMX and RDX, the major components in plastic explosives, as well as old standbys like nitroglycerin and TNT. Lia’s shoes, handbag, and briefcase were put through a separate X-ray machine and then hand-inspected, with each item in the bag and case closely examined.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She watched as the detective laid out the items in the briefcase, beginning with the laptop and its related equipment. He checked the pages of her two bound marble composition notebooks, which were blank. He turned on her phone, which wouldn’t work because of the thick metal and concrete surrounding them. He even tested her pens. Finally satisfied, he handed the case back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And my pocketbook,” said Lia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man began to explain that unnecessary personal items were kept outside the safe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have female stuff in there,” she said sharply, first in Spanish, then in English. The man’s face turned red, and he quickly handed over the bag.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It worked every time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lia’s “female stuff” amounted to two lipstick cases and a compact. She wasn’t likely to need the compact, which was actually a retina scanner, but the lipstick might come in handy—one shade concealed a solvent to unstick the bottom of the voter card envelopes without visible trace and the other a glue to reseal them. But what she really wanted were the voter cards. They’d been fitted precisely so that their outlines merged with the zipper and rivet design on the bag’s exterior and wouldn’t show up on the X-ray machine. The bag’s design was so elaborate that it had cost more to make than the cards it held.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shouldering her bag, Lia walked to the vault with Fernandez and the bank president, who was bursting with pride about his vault and the honor of helping his country preserve its democracy. The massive safe door, with its locking arms and gear work, sat to the right, folded back on its hinges against the wall. It looked like it would take two or three people simply to open or shut, but as the bank president explained, it was so carefully balanced that even a child could move it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Two UN observers—frail-looking black women from Uganda—sat on stiff-backed chairs inside the vault. According to the Art Room, they would stay the entire time until the vault was closed with the rest of the bank. One of the women held out a clipboard with a form on it, asking Lia to sign in. She did so as illegibly as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I need a card table or something,” Lia told Fernandez. “I don’t want to set up the laptop computer on the floor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A chair would be nice, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come with me,” said the bank president. “I’ll find something suitable.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lia put down her bags and then ran her hands over her face, as if rubbing some of the fatigue from the flight away. “Charlie, are you here?” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“At the check desk, waiting to open an account,” said Dean. “How you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just setting up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One of the local election officials came inside, introducing himself and going on in Spanish about how important the election was—and, Lia gathered, how important he was since he was connected with it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You will ensure a fair election by checking all the cards?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just a few.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Such a lovely tester,” said the man. “I would wager the machines will all be at their best to please you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lia bit the inside of her cheek to keep from smacking the sexist slob.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbf2d50a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429954921_ch06.vue
// module id = 84
// module chunks = 0